import React from "react";
import BlueSources from "./BlueSources";

/**
 * BlueMessage — bulle de message.
 * `role` = "user" | "blue"
 * `sources` (optionnel, réponses Blue) : sources avec badges de confiance.
 */
export function BlueMessage({ role, content, sources, testId }) {
  const isBlue = role === "blue";
  return (
    <div
      className={`blue-msg blue-msg--${isBlue ? "blue" : "user"}`}
      data-testid={testId || (isBlue ? "blue-message-blue" : "blue-message-user")}
    >
      <div className="blue-msg__wrap">
        <div className="blue-msg__bubble">{content}</div>
        {isBlue && sources && sources.length > 0 && <BlueSources sources={sources} />}
      </div>
    </div>
  );
}

export default BlueMessage;
